module.exports = __webpack_public_path__ + "img/shouye_a.c4149009.png";